import { UsernatorPromiseClient } from "../generated/user_grpc_web_pb";
import { DeleteAccountRequest, DataExport as DataExportMessage } from "../generated/user_pb";
import { AuthUser } from "../context/AuthContext";
import GRPC_BACKEND_URL, { GRPC_CLIENT_OPTIONS } from "../grpcConfig";
import { buildUserMessage } from "./drinks/utils/user";

const userClient = new UsernatorPromiseClient(GRPC_BACKEND_URL, null, GRPC_CLIENT_OPTIONS);

export const getDeletionStatus = async (user: AuthUser): Promise<string | null> => {
    const response = await userClient.getDeletionStatus(buildUserMessage(user), {});
    return response.getScheduledfor() || null;
};

export const requestAccountDeletion = async (user: AuthUser, password: string): Promise<void> => {
    const request = new DeleteAccountRequest();
    request.setUser(buildUserMessage(user));
    request.setPassword(password);
    await userClient.requestAccountDeletion(request, {});
};

export const cancelAccountDeletion = async (user: AuthUser): Promise<void> => {
    await userClient.cancelAccountDeletion(buildUserMessage(user), {});
};

export const exportMyData = async (user: AuthUser): Promise<{ fileName: string; json: string }> => {
    const response: DataExportMessage = await userClient.exportMyData(buildUserMessage(user), {});
    return { fileName: response.getFilename(), json: response.getJson() };
};
